import script from "./CheckListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckListView.vue?vue&type=script&setup=true&lang=ts"

import "./CheckListView.vue?vue&type=style&index=0&id=161b6b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161b6b12"]])

export default __exports__